import type { EngVelocityLinearRow, EngVelocityLocRow, EngVelocityPrRow } from "./engVelocityTypes";

/** The team's 1.2x velocity goal, carried on the charts as its own row. */
export const GOAL_USER = "jill";
export const GOAL_MULTIPLIER = 1.2;

function goalValue(values: number[]): number {
  return Math.round(Math.max(0, ...values) * GOAL_MULTIPLIER);
}

type LocRow = Pick<
  EngVelocityLocRow,
  "user" | "additions" | "deletions" | "operatorAdditions" | "operatorDeletions"
>;

/**
 * The goal row's lines are entirely Operators-attributed, split additions to
 * deletions the way the leading engineer's are.
 */
export function goalLocRow<T extends LocRow>(rows: T[]): LocRow {
  const total = goalValue(rows.map((row) => row.additions + row.deletions));
  const leader = rows.reduce<T | undefined>(
    (best, row) =>
      best && best.additions + best.deletions >= row.additions + row.deletions ? best : row,
    undefined,
  );
  const leaderTotal = leader ? leader.additions + leader.deletions : 0;
  const additions = leaderTotal > 0 ? Math.round((total * leader!.additions) / leaderTotal) : total;
  const deletions = total - additions;

  return {
    user: GOAL_USER,
    additions,
    deletions,
    operatorAdditions: additions,
    operatorDeletions: deletions,
  };
}

export function goalPrRow(rows: EngVelocityPrRow[]): EngVelocityPrRow {
  return {
    user: GOAL_USER,
    opened: goalValue(rows.map((row) => row.opened)),
    merged: goalValue(rows.map((row) => row.merged)),
    closedUnmerged: 0,
  };
}

export function goalLinearRow(rows: EngVelocityLinearRow[]): EngVelocityLinearRow {
  return {
    user: GOAL_USER,
    deployedToProd: goalValue(rows.map((row) => row.deployedToProd)),
  };
}
